import { stitchImageMap, type StitchImageKey } from "./config/stitch-images";

function isStitchImageKey(value: string): value is StitchImageKey {
  return Object.hasOwn(stitchImageMap, value);
}

/** Resuelve URLs de `data-stitch-img` en el documento (o en un subárbol). */
export function bindStitchImages(root: ParentNode = document): void {
  const nodes = root.querySelectorAll<HTMLImageElement>("[data-stitch-img]");
  for (const img of nodes) {
    const key = img.dataset.stitchImg;
    if (key !== undefined && isStitchImageKey(key)) {
      img.src = stitchImageMap[key];
    }
  }
}

export function imageUrlForKey(key: StitchImageKey): string {
  return stitchImageMap[key];
}
